import React from 'react'
import { Container, TituloSessao, BoxDepoimento, BoxDepoimentoFoto, BoxDepoimentoTexto, BoxDepoimentoNome, BoxDepoimentoLegenda } from './Styled'
import imagemAlexandre from 'images/promocao-cge-sp-2025/alexandre-de-assis-filho.png'
import imagemNazli from 'images/promocao-cge-sp-2025/nazli-setton.png'

export default function BannerPrincipal () {

	return (
		<Container>

			{/* Título */}
			<TituloSessao>Veja só o que alguns de nossos alunos têm a dizer<br /> sobre ferramentas da Premium:</TituloSessao>

			{/* Item Depoimento */}
			<BoxDepoimento>

				{/* Foto */}
				<BoxDepoimentoFoto src={imagemAlexandre} />

				{/* Texto */}
				<BoxDepoimentoTexto>“Com a assinatura era possível estudar para qualquer Fisco do país, sem ficar restrito às matérias<br /> contidas em um pacote específico. Além disso, teve o Passo Estratégico, PDFs com marcação dos<br /> aprovados, Mapas Mentais, Estratégia Cast, Sistema de Questões com opção de comentários<br /> curtos ou aprofundados, É muita coisa.”</BoxDepoimentoTexto>

				{/* Nome */}
				<BoxDepoimentoNome>Alexandre de Assis Filho</BoxDepoimentoNome>

				{/* Legenda */}
				<BoxDepoimentoLegenda> 1º lugar para Auditor no ISS-BH, ISS-Aracaju e Receita Federal.</BoxDepoimentoLegenda>

			</BoxDepoimento>

			{/* Item Depoimento */}
			<BoxDepoimento>

				{/* Foto */}
				<BoxDepoimentoFoto src={imagemNazli} />

				{/* Texto */}
				<BoxDepoimentoTexto>“Eu tinha a Assinatura Premium. Comecei estudando para a Receita Federal, mas como o concurso<br /> demorou para sair, mudei o foco. Das ferramentas, gostei do Estratégia Cast, Sistema de Questões,<br /> Simulados e o Passo Estratégico, que foi muito bom para revisar os assuntos mais importantes”.</BoxDepoimentoTexto>

				{/* Nome */}
				<BoxDepoimentoNome>Nazli Setton</BoxDepoimentoNome>

				{/* Legenda */}
				<BoxDepoimentoLegenda>1º lugar no TCU (Auditor), aprovada em mais de 10 concursos</BoxDepoimentoLegenda>

			</BoxDepoimento>

		</Container>
	)
}
